import { useLang } from '@/app/utils/useLang';
import VideoSection from '../Common/VideoSection';
import styles from './index.module.scss';

const CoverSection4: React.FC = () => {
    const { t } = useLang('CoverSection4');

    return (
        <div className={`page-coverSection4 ${styles.CoverSection4} GtmModuleData-section`} id="videoSection4" data-section-id="d3m-video-section4">
            <VideoSection
                sectionId="videoSection4"
                triggerSelector="#videoSection4"
                videoSrc="https://websiteoss.ecoflow.com/upload/video/1759041363178/2-04.mp4"
                posterSrc="https://websiteoss.ecoflow.com/figma-uploads/1758871247125-qr3fhe-compressed-4.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
            />
        </div>
    );
};

export default CoverSection4;
